import { createPostEndpoint } from '@sonar-software/sonar-http';

import { DateRangeQueryParams, DynamicQueryParams } from '@sonar-software/sonar-ts-types';

export type PostAuditTrailExportRequest = DateRangeQueryParams & DynamicQueryParams;

export type PostAuditTrailExportResponse = { id: number };

export const postAuditTrailExportStart = createPostEndpoint<
	PostAuditTrailExportRequest,
	PostAuditTrailExportResponse
>('/api/v3/core/exports/setup-audit-trail/export/start');
